<template>
    <field-wrapper
        id="customerName"
        :label-text="texts.label"
        :error-text="errorMessage"
        :show-error="Boolean(errorMessage)"
    >
        <input-text
            id="customerName_input"
            v-model="value"
            type="text"
            autocomplete="name"
            aria-describedby="customerName_error"
            :aria-invalid="errorMessage ? 'true' : 'false'"
        />
    </field-wrapper>
</template>

<script>
import FieldWrapper from "@/components/elements/FieldWrapper";
import InputText from "@/components/inputs/InputText";

import { mapGetters, mapMutations } from "vuex";

export default {
    components: {
        FieldWrapper,
        InputText
    },
    props: {
        validate: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        texts() {
            return this.$t("field_customer_name");
        },
        value: {
            get() {
                return this.name || "";
            },
            set(name) {
                this.updateCustomer({ name });
            }
        },
        errorMessage() {
            if (this.validate && this.error)
                return this.$t(`field_customer_name.${this.error}`, 1, {
                    invalidChars: this.invalidChars.join("")
                });
            return null;
        },
        ...mapGetters({
            name: "customer/getName",
            invalidChars: "customer/getNameInvalidChars",
            error: "customer/getNameError"
        })
    },
    methods: {
        ...mapMutations({
            updateCustomer: "customer/updateCustomer"
        })
    }
};
</script>
